<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        产品信息
      </div>
      <div style="margin: 10px 10px 10px 0; display: inline-block">
        退货地址：{{ this.allAddress }},{{ this.userName }},{{ this.telNum }}
      </div>
      <!-- <el-button type="primary" v-if="this.$route.query.contratType!=='齐套不提货撤单'" @click="setSerialNum">批量选择退货产品序列号</el-button> -->
      <div class="rj-page-card__content">
        <el-table
          :data="
            rejectedList.length === 0
              ? []
              : rejectedList[0].addressList[0].contractProductList
          "
          border
          style="width: 100%"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="rproductCode"
            label="销售产品代码"
            align="left"
            width="120"
          />
          <el-table-column
            prop="rproductSalesName"
            label="商品名称"
            align="left"
            width="180"
            fixed="left"
          />
          <el-table-column
            prop="rproductName"
            label="产品型号"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rmaterialNum"
            label="物料编码"
            align="left"
            width="180"
          />
          <el-table-column
            prop="rproductUnit"
            label="单位"
            align="left"
            width="80"
          />
          <el-table-column
            prop="rproductNum"
            label="数量"
            align="left"
            width="100"
          >
            <template slot-scope="{ row }">
              -{{ row.rproductNum }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rproductPrice"
            label="单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rproductPriceAdd"
            label="订单金额"
            align="right"
            header-align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              -{{ row.rproductPriceAdd }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rproductActualPriceAdd"
            label="实际结算金额"
            align="right"
            header-align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              -{{ row.rproductActualPriceAdd }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rbeforeSplitPrice"
            label="拆分前单价"
            align="right"
            header-align="left"
            width="180"
          />
          <el-table-column
            prop="rdeliverSign"
            label="发货状态"
            align="left"
            width="180"
          >
            <template slot-scope="{ row }">
              {{ shipmentStatus[row.rdeliverSign] }}
            </template>
          </el-table-column>
          <el-table-column
            prop="rfictitiousReturn"
            label="真实/虚拟退货"
            align="left"
            width="180"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rfictitiousReturn">真实退</span>
              <span v-if="!scope.row.rfictitiousReturn">虚拟退</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxRate"
            label="税率"
            align="left"
            width="120"
          />
          <el-table-column
            v-if="this.$route.query.contratType !== '齐套不提货撤单'"
            prop="returntDelivery"
            label="退货序列号"
            align="left"
            width="180"
          />
          <el-table-column
            v-if="this.$route.query.contratType !== '齐套不提货撤单'"
            label="操作"
            align="left"
            width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.rdeliverSign !== 0"
                type="primary"
                @click="setSerialNum(scope.row, scope.$index)"
              >
                选择退货产品序列号
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <set-serial
        :dialogvisible="dialogVisibleBool"
        :row-data="rowData"
        :set-serial-data="setSerialData"
        @setSerialClose="setSerialClose"
        @setProductSn="setProductSn"
        @getTableData="getTableData"
      />
    </div>
  </div>
</template>

<script>
import setSerial from './serSerial.vue';
import { MathAdd } from '@/libs/util';
export default {
  name: 'RejectedList',
  data () {
    return {
      rejectedList: this.productData,
      dialogVisibleBool: false,
      setSerialData: {},
      rowData: {},
      // 所选择行
      currentIdex: null,
      snNumber: '',
      // 发货状态
      shipmentStatus: {
        0: '未发货',
        1: '已发货',
        2: '异常'
      }
      // allCont: 0
    };
  },
  components: {
    setSerial
  },
  computed: {
    allAddress () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rfullAddress;
      }
      return res;
    },
    userName () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rreceiveUserName;
      }
      return res;
    },
    telNum () {
      let res = '';
      if (this.rejectedList.length === 0) {
        res = '';
      } else {
        res = this.rejectedList[0].addressList[0].rreceiveTel;
      }
      return res;
    }
  },
  props: {
    productData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    productData (val) {
      this.rejectedList = val;
    }
  },
  methods: {
    // 设置序列号
    setSerialNum (row, index) {
      this.dialogVisibleBool = true;
      this.rowData = row;
      this.currentIdex = index;
      this.setSerialData = {
        contractId: 1,
        getGoodsList: 2
      };
      // this.$notify.error({
      //   message: '设置冲销序列号'
      // });
    },
    setProductSn (val) {
      let productSnList = val;
      this.rejectedList[0].addressList[0].contractProductList.forEach(
        (item, index) => {
          this.snNumber = '';
          productSnList.forEach((sn) => {
            if (item.rmaterialNum === sn.materialCode) {
              this.snNumber = ',' + sn.snNumber + this.snNumber;
            }
          });
          // 防止错行操作 只针对当前行赋值
          if (index === this.currentIdex) {
            this.$set(item, 'returntDelivery', this.snNumber.substring(1));
          }
        }
      );
      this.$emit('setProductSn', productSnList);
    },
    setSerialClose (val) {
      this.dialogVisibleBool = val;
    },
    getTableData (val) {
      this.rejectedList = val;
    },
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.rproductNumAmount(param.data);
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.rproductPriceAddAmount(param.data);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.rproductActualPriceAddAmount(param.data);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.rbeforeSplitPriceAmount(param.data);
        }
      });
      return sums;
    },
    rproductNumAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductNum);
      });
      return `-${cont}`;
    },
    rproductPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductPriceAdd);
      });
      return `-${cont.toFixed(2)}`;
    },
    rbeforeSplitPriceAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rbeforeSplitPrice);
      });
      return cont.toFixed(2);
    },
    rproductActualPriceAddAmount (tag) {
      let cont = 0;
      tag.forEach((item) => {
        cont = MathAdd(cont, item.rproductActualPriceAdd);
      });
      // this.allCont = cont;
      return `-${cont.toFixed(2)}`;
    }
  }
};
</script>

<style lang="scss"></style>
